/**
 * The search box of a list that arrives whole, matched on screen.
 *
 * Nobody types accents into a search box consistently, so «sesion» has to find «Sesión» and the
 * other way round; and «ana gestos» should find Ana's gesture configuration even though her name
 * and «gestos» live in different columns. Each word has to appear somewhere, in any order.
 */

/** Combining marks, once a letter has been split from its accent (NFD). */
const MARKS = /\p{M}/gu;

/**
 * Text as a search compares it: lower-case, without accents, trimmed.
 *
 * Lower-cased before the accents go, because a few capitals lower-case into a letter plus a mark
 * («İ» becomes «i» and a dot) and the mark would otherwise survive. «ñ» becomes «n» on both sides,
 * so «espana» finds «España» and «España» still finds itself.
 */
export function normalizeForSearch(text: string): string {
  return text.toLowerCase().normalize('NFD').replace(MARKS, '').trim();
}

/**
 * Whether the fields answer the term: every word of it appears in one field or another.
 *
 * An empty term matches everything — a cleared search box is no search — and a missing field is
 * simply not searched.
 */
export function matchesSearch(fields: readonly (string | null | undefined)[], term: string): boolean {
  const words = normalizeForSearch(term).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;

  const haystacks = fields.flatMap((field) => (field ? [normalizeForSearch(field)] : []));

  return words.every((word) => haystacks.some((haystack) => haystack.includes(word)));
}
